import { useContext } from 'react';
import { Navigate } from 'react-router-dom';
import { MyContext } from '../context';

// Guards the Approvals page the same way RoleRoute guards role-gated pages,
// but on the orthogonal is_order_approver flag instead of role (an ADMIN or
// PLATFORMADMIN isn't automatically an approver, and an approver isn't
// automatically an ADMIN -- see orderApprovals.service.ts's
// assertOrderApprovalPermission, which is this same "PLATFORMADMIN, this
// store's ADMIN, or is_order_approver" rule server-side). Whether the store
// has order approval turned on is no longer checked here -- the page is
// always reachable for admins/approvers, and renders an empty state itself
// when the store's requireOrderApproval toggle is off.
const ApproverRoute = ({ children }) => {
	const { userProfile, activeStoreRole, activeStoreIsOrderApprover } = useContext(MyContext);
	const isAdmin = userProfile?.role === 'PLATFORMADMIN' || activeStoreRole === 'ADMIN';
	const canApprove = isAdmin || activeStoreIsOrderApprover;

	if (!canApprove) {
		return <Navigate to='/' replace />;
	}

	return children;
};

export default ApproverRoute;
